import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/theme.css';

function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', flexDirection: 'column', gap: '1rem', textAlign: 'center', padding: '2rem' }}>
      <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'rgba(239,68,68,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem', color: 'var(--danger)' }}>
        <i className="fas fa-times-circle"></i>
      </div>
      <h1 style={{ color: 'var(--text-primary)', margin: 0 }}>Payment Cancelled</h1>
      <p style={{ color: 'var(--text-muted)', maxWidth: 400 }}>No charges were made. You can upgrade anytime from the pricing page.</p>
      <button className="btn btn-primary" onClick={() => navigate('/pricing')}>View Plans</button>
    </div>
  );
}

export default PaymentCancel;
